import { AppActionType } from "components/app/constants";

export const getDefaultState = () => ({
  busy: false,
  toast: {
    message: "",
    type: "",
  },
  drawer: false,
  chartDrawer: false,
  chartDrawerDisabled: false,
  page: "Home",
  waterUserType: "Cities"
});

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case AppActionType.APP_BUSY:
      return setAppBusy(state, action.payload);
    case AppActionType.SET_TOAST_MESSAGE:
      return setToastMessage(state, action.payload);
    case AppActionType.REMOVE_TOAST_MESSAGE:
      return removeToastMessage(state);
    case AppActionType.SET_DRAWER_STATE:
      return setDrawerState(state);
    case AppActionType.SET_CHART_DRAWER_STATE:
      return setChartDrawerState(state);
    case AppActionType.SET_CHART_DRAWER_STATE_TO_CLOSE:
      return setChartDrawerStateToClose(state);
    case AppActionType.DISABLE_CHART_DRAWER:
        return disableChartDrawer(state);
    case AppActionType.ENABLE_CHART_DRAWER:
        return enableChartDrawer(state);
    case AppActionType.CHANGE_PAGE:
      return changeNavigationPage(state, action.payload);
    case AppActionType.SET_WATER_USER_TYPE:
      return setWaterUserType(state, action.payload)
    default:
      return state;
  }
};

const setWaterUserType = (state, { type }) => {
  return {
    ...state,
    waterUserType: type
  }
}

const changeNavigationPage = (state, { page }) => {
  return {
    ...state,
    page
  };
};

const setAppBusy = (state, { busy }) => {
  return {
    ...state,
    busy,
  };
};

const setToastMessage = (state, { message, type }) => {
  return {
    ...state,
    toast: { message, type },
  };
};

const removeToastMessage = (state) => {
  return {
    ...state,
    toast: { message: "", type: "" },
  };
};
function setDrawerState(state) {
  return {
    ...state,
    drawer: !state.drawer,
  };
}
function setChartDrawerState(state) {
  if (state.chartDrawerDisabled) {
    return {
      ...state,
      chartDrawer: state.chartDrawer,
    };
  }
  return {
    ...state,
    chartDrawer: !state.chartDrawer,
  };
}
function setChartDrawerStateToClose(state) {
  //if disabled, we can't perform any actions on it
  if (state.chartDrawerDisabled) {
    return {
      ...state,
      chartDrawer: state.chartDrawer,
    };
  }
  if (state.chartDrawer) {
    return {
      ...state,
      chartDrawer: false,
    };
  }
  else {
    return {
      ...state,
    }
  }
}

function disableChartDrawer(state) {
  if (!state.chartDrawerDisabled) {
    return {
      ...state,
      chartDrawer: false,
      chartDrawerDisabled: true,
    };
  }
  else {
    return {
      ...state,
    }
  }
}

function enableChartDrawer(state) {
  if (state.chartDrawerDisabled) {
    return {
      ...state,
      chartDrawerDisabled: false,
    };
  }
  else {
    return {
      ...state,
    }
  }
}
